module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Indiana PGA-69b4750aedff490301d960585d8d8812.jpg";